import Vue from 'vue'
import store from '@/store'
/**
 * 使用：v-permission=[1]
 * **/
Vue.directive('permission', {
  inserted(el, vDir) {
    const btnPermission = store.getters.roles
    if (btnPermission.includes(1) || btnPermission.includes(3)) return
    if (vDir.value) {
      const even = (element) => vDir.value.includes(element)
      if (!btnPermission.some(even)) {
        el.parentNode.removeChild(el)
      }
    }
  }
})
